export const IMAGES = {
  profile:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_5e9de2d7-9bba-43a3-b896-c6aa8c4fdf5c/artifacts/2d6e0e0a43ffe6cf_image.png",
  waiting:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_5e9de2d7-9bba-43a3-b896-c6aa8c4fdf5c/artifacts/5ee10dbb4226f4fa_image.png",
  treatment:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_5e9de2d7-9bba-43a3-b896-c6aa8c4fdf5c/artifacts/2ddf4379cb92a955_image.png",
};

export const CONTACT = {
  email: "claudia.ajmone@gmail.com",
  phoneTorino: "3388203201",
  phoneTorinoLabel: "338 820 3201",
  phoneCarignano: "0119690786",
  phoneCarignanoLabel: "011 969 0786",
};

const services = [
  {
    id: "consulenza-iniziale",
    dur: "15 min",
    it: {
      title: "Consulenza Iniziale",
      desc: "Breve colloquio, raccolta dell'anamnesi e valutazione osteopatica mirata per individuare l'approccio più appropriato.",
    },
    en: {
      title: "Initial Consultation",
      desc: "Brief conversation, health history and focused osteopathic assessment to identify the most appropriate approach.",
    },
  },
  {
    id: "trattamento-personalizzato",
    dur: "60 / 90 min",
    it: {
      title: "Trattamento Osteopatico Personalizzato",
      desc: "Seduta su misura che integra tecniche muscolo-scheletriche, miofasciali, viscerali, cranio-sacrali e fluidiche in base alla valutazione individuale.",
    },
    en: {
      title: "Personalised Osteopathic Treatment",
      desc: "A tailored session integrating musculoskeletal, myofascial, visceral, cranio-sacral and fluid-based techniques according to the individual assessment.",
    },
  },
  {
    id: "postura-muscoloscheletrico",
    dur: "60 / 90 min",
    it: {
      title: "Postura e Rilascio Muscolo-Scheletrico",
      desc: "Focalizzato su mobilità, equilibrio posturale, sovraccarichi muscolari e tensioni miofasciali, con attenzione a colonna, spalle e arti inferiori.",
    },
    en: {
      title: "Posture & Musculoskeletal Release",
      desc: "Focused on mobility, postural balance, muscular overload and myofascial tension, with attention to the spine, shoulders and lower limbs.",
    },
  },
  {
    id: "cranio-sacrale",
    dur: "45 / 60 min",
    it: {
      title: "Trattamento Cranio-Sacrale",
      desc: "Un approccio dolce e non invasivo, per chi preferisce tecniche manuali sottili e un'esperienza di trattamento profondamente rilassante.",
    },
    en: {
      title: "Cranio-Sacral Osteopathic Treatment",
      desc: "A gentle, non-invasive approach for guests who prefer subtle manual techniques and a deeply relaxing treatment experience.",
    },
  },
  {
    id: "viscerale",
    dur: "60 min",
    it: {
      title: "Osteopatia Viscerale",
      desc: "Lavoro manuale delicato sulle restrizioni funzionali e sulla mobilità della regione addominale e viscerale, nell'ambito di una valutazione osteopatica completa.",
    },
    en: {
      title: "Visceral Osteopathy",
      desc: "Gentle manual work addressing functional restrictions and mobility within the abdominal and visceral regions as part of a comprehensive osteopathic assessment.",
    },
  },
  {
    id: "respirazione-diaframma",
    dur: "45 / 60 min",
    it: {
      title: "Respirazione e Diaframma",
      desc: "Tecniche manuali e funzionali mirate alla mobilità del diaframma, alla meccanica toracica, alla postura e alla facilità del respiro.",
    },
    en: {
      title: "Breathing & Diaphragm Work",
      desc: "Manual and functional techniques focused on diaphragm mobility, thoracic mechanics, posture and ease of breathing.",
    },
  },
  {
    id: "fluidi-linfatico",
    dur: "60 min",
    it: {
      title: "Tecniche Fluidiche e Osteo-Linfatiche",
      desc: "Tecniche dolci per sostenere la mobilità dei tessuti e la dinamica dei fluidi, quando è indicato un approccio più leggero e rigenerante.",
    },
    en: {
      title: "Fluid & Osteo-Lymphatic Techniques",
      desc: "Gentle techniques aimed at supporting tissue mobility and fluid dynamics when a lighter, restorative approach is appropriate.",
    },
  },
];

const faqs = [
  {
    it: {
      q: "Cos'è l'osteopatia e come funziona l'approccio globale?",
      a: "L'osteopatia è una disciplina manuale che considera il corpo come un'unità funzionale indissolubile. L'approccio globale integra sistema muscolo-scheletrico, fascia, visceri, diaframmi e dinamica dei fluidi per individuare e trattare la causa primaria del disturbo, non solo il sintomo.",
    },
    en: {
      q: "What is osteopathy and how does the global approach work?",
      a: "Osteopathy is a manual health discipline that views the body as an integrated functional unit. The global approach addresses the musculoskeletal system, fascia, viscera, diaphragms and fluid dynamics to locate and treat the root cause of discomfort.",
    },
  },
  {
    it: {
      q: "Serve una prescrizione medica per una seduta di osteopatia?",
      a: "No, non è necessaria alcuna prescrizione. Ogni prima seduta inizia con un'anamnesi approfondita: se emergono condizioni che richiedono indagini medico-specialistiche, sarai indirizzato al professionista competente.",
    },
    en: {
      q: "Do I need a doctor's prescription for a session?",
      a: "No prescription is required. Every first session begins with a comprehensive health history; if medical referral is appropriate, you will be guided to the right specialist.",
    },
  },
  {
    it: {
      q: "Come si svolge la prima visita e cosa devo portare?",
      a: "La prima visita comprende colloquio anamnestico, analisi della documentazione medica ed esami recenti (radiografie, risonanze, ecografie), valutazione posturale e palpatoria, e un primo trattamento. È consigliato un abbigliamento comodo.",
    },
    en: {
      q: "What happens during the first appointment?",
      a: "The first visit includes a health-history dialogue, review of recent diagnostic reports (X-rays, MRIs, ultrasounds), postural and palpatory assessment, and an initial treatment. Comfortable clothing is recommended.",
    },
  },
  {
    it: {
      q: "In cosa il tuo percorso biomedico arricchisce la pratica osteopatica?",
      a: "Alla qualifica di Osteopata D.O. affianco l'iscrizione all'Albo TSRM come Tecnico Sanitario di Laboratorio Biomedico, con esperienza in genetica medica, diagnosi prenatale e medicina della riproduzione: questo garantisce rigore clinico, lettura accurata degli esami diagnostici e un dialogo qualificato con i medici specialisti.",
    },
    en: {
      q: "How does your biomedical background enhance your practice?",
      a: "Alongside the Osteopath D.O. qualification, I am a TSRM-registered Biomedical Laboratory Technologist with experience in medical genetics, prenatal diagnosis and reproductive medicine — ensuring clinical rigour, accurate reading of diagnostic reports and qualified dialogue with medical specialists.",
    },
  },
  {
    it: {
      q: "Dove si trovano gli studi e come posso prenotare?",
      a: "Torino: Centro H3O, Corso Unione Sovietica 115 — info e prenotazioni al 338 820 3201. Carignano: Piazzetta San Giacomo 11/12 — segreteria 011 969 0786. Puoi anche scrivere a claudia.ajmone@gmail.com.",
    },
    en: {
      q: "Where are the studios and how do I book?",
      a: "Turin: Centro H3O, Corso Unione Sovietica 115 — bookings at 338 820 3201. Carignano: Piazzetta San Giacomo 11/12 — reception 011 969 0786. You can also email claudia.ajmone@gmail.com.",
    },
  },
];

const studios = [
  {
    id: "torino",
    name: "Centro H3O",
    city: "Torino",
    address: "Corso Unione Sovietica 115, 10134 Torino (TO)",
    phone: CONTACT.phoneTorino,
    phoneLabel: CONTACT.phoneTorinoLabel,
    map: "https://www.google.com/maps?q=Corso%20Unione%20Sovietica%20115%2C%20Torino&output=embed",
    link: "https://www.google.com/maps/search/?api=1&query=Corso+Unione+Sovietica+115+Torino",
  },
  {
    id: "carignano",
    name: "Studio Carignano",
    city: "Carignano",
    address: "Piazzetta San Giacomo 11/12, 10041 Carignano (TO)",
    phone: CONTACT.phoneCarignano,
    phoneLabel: CONTACT.phoneCarignanoLabel,
    map: "https://www.google.com/maps?q=Piazzetta%20San%20Giacomo%2011%2C%20Carignano&output=embed",
    link: "https://www.google.com/maps/search/?api=1&query=Piazzetta+San+Giacomo+11+Carignano",
  },
];

export const content = {
  it: {
    nav: {
      about: "Chi sono",
      services: "Trattamenti",
      studios: "Studi",
      faq: "FAQ",
      contact: "Contatti",
      book: "Prenota",
    },
    hero: {
      eyebrow: "Osteopata D.O. · Torino & Carignano",
      lines: ["Claudia", "D'Elia"],
      subtitle: "Osteopatia e scienze biomediche: un approccio globale alla persona",
      intro:
        "Osteopata D.O. iscritta al ROI e Tecnico Sanitario di Laboratorio Biomedico. Ogni trattamento nasce dall'ascolto, dall'anamnesi e da una valutazione individuale.",
      ctaEmail: "Scrivimi una email",
      ctaTorino: "Studio Torino",
      ctaCarignano: "Studio Carignano",
      scroll: "Scorri",
    },
    marquee: [
      "Osteopatia Globale",
      "Medicina della Riproduzione",
      "Diagnosi Prenatale",
      "Registro ROI",
      "Albo TSRM",
      "Diaframmi e Respirazione",
      "Dinamica dei Fluidi",
    ],
    bio: {
      eyebrow: "Profilo professionale",
      title: "Tra scienza biomedica e medicina manuale",
      p1: "Sono Osteopata D.O., iscritta al ROI – Registro degli Osteopati d'Italia, e Tecnico Sanitario di Laboratorio Biomedico, iscritta all'Albo TSRM. Il mio percorso unisce osteopatia e scienze biomediche, con esperienza universitaria, ospedaliera e clinica in genetica medica, diagnosi prenatale, medicina della riproduzione e infertilità di coppia.",
      p2: "Dal 2016 studio e applico l'osteopatia, integrando progressivamente il mio background scientifico con i principi della disciplina. L'ascolto, l'anamnesi e la valutazione individuale guidano ogni trattamento, in un approccio globale che considera sistema muscolo-scheletrico, fascia, mobilità viscerale, respirazione, diaframmi e dinamica dei fluidi. Il mio lavoro accoglie ogni fascia d'età, dall'adolescenza all'età matura, con percorsi di cura sempre costruiti sulla singola persona.",
      pillarsTitle: "L'approccio globale considera",
      pillars: [
        "Sistema muscolo-scheletrico",
        "Fascia",
        "Mobilità viscerale",
        "Respirazione e diaframmi",
        "Dinamica dei fluidi",
      ],
      badgeRoi: "Iscritta al ROI",
      badgeRoiSub: "Registro degli Osteopati d'Italia",
      badgeTsrm: "Albo TSRM",
      badgeTsrmSub: "Tecnico Sanitario di Laboratorio Biomedico",
      since: "Dal 2016",
      sinceSub: "studio e pratica osteopatica",
    },
    services: {
      eyebrow: "Trattamenti",
      title: "Servizi osteopatici",
      sub: "Ogni seduta è preceduta da ascolto e valutazione individuale. I trattamenti sono rivolti a ogni fascia d'età, dall'adolescenza all'età matura, con percorsi sempre adattati alle esigenze della persona. Le durate indicano la lunghezza del trattamento.",
      bookCta: "Prenota",
    },
    studios: {
      eyebrow: "Dove ricevo",
      title: "Due studi, un unico approccio",
      torinoPhoneLabel: "Info e prenotazioni",
      carignanoPhoneLabel: "Segreteria studio",
      openMaps: "Apri in Google Maps",
      hours: "Prenotazioni telefoniche",
      hoursTorino: "Per prenotare chiamare il 338 820 3201",
      hoursCarignano: "Per prenotare chiamare lo 011 969 0786",
      call: "Chiama",
    },
    faq: {
      eyebrow: "Domande frequenti",
      title: "Prima della tua visita",
    },
    footer: {
      title: "Prenota la tua visita",
      sub: "Scegli lo studio più comodo per te: basta una telefonata o una email.",
      emailLabel: "Email",
      torinoLabel: "Studio Torino — Centro H3O",
      carignanoLabel: "Studio Carignano — Segreteria",
      likePrompt: "Ti piace questo sito?",
      likeThanks: "Grazie per il tuo apprezzamento!",
      likeCount: "persone lo apprezzano",
      rights: "Tutti i diritti riservati.",
      role: "Osteopata D.O. · ROI · TSRM",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Treatments",
      studios: "Studios",
      faq: "FAQ",
      contact: "Contact",
      book: "Book now",
    },
    hero: {
      eyebrow: "Osteopath D.O. · Turin & Carignano",
      lines: ["Claudia", "D'Elia"],
      subtitle: "Osteopathy meets biomedical science: a whole-person approach",
      intro:
        "ROI-registered Osteopath D.O. and Biomedical Laboratory Technologist. Every treatment begins with listening, history-taking and individual assessment.",
      ctaEmail: "Email me",
      ctaTorino: "Turin Studio",
      ctaCarignano: "Carignano Studio",
      scroll: "Scroll",
    },
    marquee: [
      "Global Osteopathy",
      "Reproductive Medicine",
      "Prenatal Diagnosis",
      "ROI Register",
      "TSRM Board",
      "Diaphragms & Breathing",
      "Fluid Dynamics",
    ],
    bio: {
      eyebrow: "Professional profile",
      title: "Where biomedical science meets manual medicine",
      p1: "I am an Osteopath D.O., registered with ROI – the Italian Register of Osteopaths, and a Biomedical Laboratory Technologist, registered with the TSRM professional board. My path unites osteopathy and biomedical sciences, with university, hospital and clinical experience in medical genetics, prenatal diagnosis, reproductive medicine and couple infertility.",
      p2: "Since 2016 I have studied and practiced osteopathy, progressively integrating my scientific background with the principles of the discipline. Listening, history-taking and individual assessment guide every treatment, within a global approach that considers the musculoskeletal system, fascia, visceral mobility, breathing, diaphragms and fluid dynamics. My work welcomes every stage of life, from adolescence through the senior years, with care always built around the individual.",
      pillarsTitle: "The global approach considers",
      pillars: [
        "Musculoskeletal system",
        "Fascia",
        "Visceral mobility",
        "Breathing & diaphragms",
        "Fluid dynamics",
      ],
      badgeRoi: "ROI Registered",
      badgeRoiSub: "Italian Register of Osteopaths",
      badgeTsrm: "TSRM Board",
      badgeTsrmSub: "Biomedical Laboratory Technologist",
      since: "Since 2016",
      sinceSub: "studying and practicing osteopathy",
    },
    services: {
      eyebrow: "Treatments",
      title: "Osteopathic services",
      sub: "Every session begins with listening and individual assessment. Treatments are suited to every stage of life, from adolescence through the senior years, with care always tailored to the person. Durations indicate treatment length.",
      bookCta: "Book",
    },
    studios: {
      eyebrow: "Locations",
      title: "Two studios, one approach",
      torinoPhoneLabel: "Info & bookings",
      carignanoPhoneLabel: "Studio reception",
      openMaps: "Open in Google Maps",
      hours: "Phone bookings",
      hoursTorino: "To book, call 338 820 3201",
      hoursCarignano: "To book, call 011 969 0786",
      call: "Call",
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "Before your visit",
    },
    footer: {
      title: "Book your visit",
      sub: "Choose the studio that suits you best: a phone call or an email is all it takes.",
      emailLabel: "Email",
      torinoLabel: "Turin Studio — Centro H3O",
      carignanoLabel: "Carignano Studio — Reception",
      likePrompt: "Do you like this site?",
      likeThanks: "Thank you for your appreciation!",
      likeCount: "people appreciate it",
      rights: "All rights reserved.",
      role: "Osteopath D.O. · ROI · TSRM",
    },
  },
  services,
  faqs,
  studios,
};
